export const ERP_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp']
export const ERP_IMAGE_MAX_BYTES = 5 * 1024 * 1024

/** Returns an error message, or null when the file can be uploaded. */
export function validateErpImage(file: File): string | null {
  if (!ERP_IMAGE_TYPES.includes(file.type))
    return `Unsupported image type ${file.type || '(unknown)'} — use PNG, JPEG or WebP`
  if (file.size > ERP_IMAGE_MAX_BYTES)
    return `Image is ${(file.size / 1024 / 1024).toFixed(1)} MB — max 5 MB`
  return null
}

/** First image file in a paste/drop DataTransfer, if any. */
export function imageFromDataTransfer(dt: DataTransfer | null): File | null {
  if (!dt) return null
  for (const item of Array.from(dt.items ?? [])) {
    if (item.kind === 'file' && item.type.startsWith('image/')) {
      const file = item.getAsFile()
      if (file) return namedFile(file, item.type)
    }
  }
  for (const file of Array.from(dt.files ?? [])) {
    if (file.type.startsWith('image/')) return file
  }
  return null
}

// Clipboard images arrive as "image.png" or with no name; give them one.
export function namedFile(blob: Blob, type: string): File {
  const ext = type.split('/')[1]?.replace('jpeg', 'jpg') || 'png'
  const name =
    blob instanceof File && blob.name && blob.name !== 'image.png'
      ? blob.name
      : `erp-schematic-${Date.now()}.${ext}`
  return new File([blob], name, { type })
}
